import { memo } from 'react';
import { RawHtml } from '@divlab/divanui';
import { IconQuote } from '@divlab/divanui/icons';

import useTranslation from '@Queries/useTranslation';
import Img from '@UI/Img';
import photos from './assets';
import styles from './OurTeam.module.css';

import type { FC, HTMLAttributes } from 'react';
import type { PersonData } from '@Pages/PageExpressDesign/type';

interface OurTeamProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  team: PersonData[];
}

const OurTeam: FC<OurTeamProps> = (props) => {
  const { team, ...restProps } = props;
  const { t } = useTranslation();

  return (
    <div {...restProps}>
      <div className={styles.title}>{t('our-team')}</div>
      <div className={styles.subtitle}>{t('let-meet-people')}</div>
      <div className={styles.team}>
        {team.map(({ photo, name, quote, id }) => {
          return (
            <div className={styles.person} key={id}>
              <div>
                <Img className={styles.imageWrapper} cnImage={styles.image} src={photos[photo]} />
              </div>
              <div className={styles.textWrapper}>
                <div className={styles.name}>{name}</div>
                <div className={styles.quote}>
                  <IconQuote className={styles.icon} />
                  <RawHtml className={styles.text} html={quote} />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default memo(OurTeam);
